<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-bread-crumb [breadcrumbs]="breadcrumbs()" ariaLabel="Edit Third Party"></aw-bread-crumb>

  <aw-toast></aw-toast>
  <app-unsaved-changes-dialog></app-unsaved-changes-dialog>

  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Edit Third Party'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="form-container">
    <app-aw-text-form
      class="input"
      [disable]="false"
      [readOnly]="organization === 'integration-employee'"
      [required]="true"
      [value]="nameInput"
      title="Third-Party Name"
      [multiline]="true"
      [maxCharacters]="nameMaxLength"
      [allowedPattern]="namePattern"
      [patternMessage]="namePatternMessage"
      (textEntry)="onNameSelected($event)"
    ></app-aw-text-form>

    @if (organization === 'assetworks-employee') {
    <app-aw-dropdown-form
      class="input"
      [options]="statusOptions()"
      [label]="selectedStatusOption()?.label ?? ''"
      title="Status"
      (currentOption)="onStatusSelected($event)"
    ></app-aw-dropdown-form>
    } @else {
    <app-aw-text-form
      class="input"
      [readOnly]="true"
      [required]="false"
      title="Status"
      [value]="statusInput()"
    ></app-aw-text-form>
    }
  </div>

  <div class="employee-auth-details-container">
    <aw-divider
      [inset]="false"
      [middleInset]="false"
      [subTitle]="'Third-Party Employee Authentication'"
      [altColor]="true"
    >
    </aw-divider>

    <div class="auth-type-label">
      <label class="aw-st-1-medium aw-text-primary">Authentication Type: OpenID Connect</label>
    </div>

    <app-aw-auth-form
      [authType]="employeeAuthTypeValue"
      [values]="employeeAuthFieldsValues"
      [editMode]="true"
      [authenticationVersion]="'employee'"
      (valuesChangedEvent)="onEmployeeAuthValuesChanged($event)"
    ></app-aw-auth-form>
  </div>
</div>
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"></aw-action-bar>
</div>
